"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wishlist = void 0;
const type_graphql_1 = require("type-graphql");
const Route_1 = require("./Route");
const WishlistLocations_1 = require("./WishlistLocations");
// TODO: move this into api graphql types definitions
let Wishlist = class Wishlist {
    routes;
    locations;
};
exports.Wishlist = Wishlist;
__decorate([
    (0, type_graphql_1.Field)(() => [Route_1.Route]),
    __metadata("design:type", Array)
], Wishlist.prototype, "routes", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => WishlistLocations_1.WishlistLocations),
    __metadata("design:type", WishlistLocations_1.WishlistLocations)
], Wishlist.prototype, "locations", void 0);
exports.Wishlist = Wishlist = __decorate([
    (0, type_graphql_1.ObjectType)("Wishlist")
], Wishlist);
//# sourceMappingURL=Wishlist.js.map